import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const OAuthCallback: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processedRef = useRef(false); // To prevent double execution

  useEffect(() => {
    if (processedRef.current) return; // Run only once
    processedRef.current = true;

    // 1. URL se Query Params nikalo
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const name = searchParams.get('name');
    const email = searchParams.get('email');

    console.log("OAuth Callback Triggered:", { token, name, email });

    if (token && name) {
      // 2. AuthContext ke zariye Login karo (Ye localStorage me save karega)
      login(token, { name, email: email || "" });
      
      console.log("Login Successful, Redirecting...");

      // 3. Home page par wapas bhej do
      // (Thoda delay taaki state update ho sake)
      setTimeout(() => {
        navigate('/', { replace: true });
      }, 100);
      
    } else {
      console.error("Token missing in URL");
      navigate('/');
    }
  }, [location, login, navigate]);

  return (
    <div className="h-screen flex flex-col items-center justify-center bg-white">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600 mb-4"></div>
      <p className="text-gray-600 font-medium">Processing secure login...</p>
    </div>
  );
};

export default OAuthCallback;